import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

// Logo importeren
import logoLionsInternational from '../assets/images/logo lions international.png';

// Animatie varianten
const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6 }
  }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const About: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="relative bg-lions-dark text-white py-20">
        <div className="absolute inset-0 z-0">
          <img 
            src="/images/about-hero.jpg" 
            alt="Over Lions Club Hoorn De Doelen" 
            className="w-full h-full object-cover opacity-30"
          />
        </div>
        <div className="container-custom relative z-10">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={staggerContainer}
            className="max-w-3xl"
          >
            <motion.h1 
              variants={fadeIn}
              className="text-4xl md:text-5xl font-bold mb-6"
            >
              Over <span className="text-lions-yellow">Lions Club</span> Hoorn De Doelen
            </motion.h1>
            <motion.p 
              variants={fadeIn}
              className="text-xl mb-8 text-gray-200"
            >
              Leer meer over onze club, onze geschiedenis en onze missie om de gemeenschap te dienen.
            </motion.p>
          </motion.div>
        </div>
      </section>

      {/* Over Ons Section */}
      <section className="section bg-white dark:bg-lions-dark">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
              variants={staggerContainer}
            >
              <motion.h2 
                variants={fadeIn}
                className="text-3xl md:text-4xl font-bold mb-6 text-lions-blue dark:text-lions-yellow"
              >
                Wie zijn wij?
              </motion.h2>
              <motion.p 
                variants={fadeIn}
                className="text-lg mb-6 dark:text-gray-300"
              >
                Lions Club Hoorn De Doelen is opgericht op 11 juni 2005 en maakt deel uit van Lions Clubs International, 's werelds grootste serviceclub-organisatie met meer dan 1,4 miljoen leden in meer dan 200 landen.
              </motion.p>
              <motion.p 
                variants={fadeIn}
                className="text-lg mb-6 dark:text-gray-300"
              >
                Onze club bestaat uit betrokken mannen uit Hoorn en omgeving die zich vrijwillig inzetten voor het goede doel. We organiseren diverse activiteiten en evenementen om fondsen te werven voor lokale en internationale projecten.
              </motion.p>
              <motion.p 
                variants={fadeIn}
                className="text-lg mb-6 dark:text-gray-300"
              >
                We komen twee keer per maand samen in Restaurant De Nadorst in Blokker om onze activiteiten te bespreken en te plannen.
              </motion.p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6 }}
              className="rounded-lg overflow-hidden shadow-xl"
            >
              <img 
                src="/images/about-team.jpg" 
                alt="Lions Club Hoorn De Doelen team" 
                className="w-full h-auto"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Onze Missie Section */}
      <section className="section bg-lions-light dark:bg-gray-900">
        <div className="container-custom">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={staggerContainer}
            className="text-center max-w-3xl mx-auto"
          >
            <motion.h2 
              variants={fadeIn}
              className="text-3xl md:text-4xl font-bold mb-6 text-lions-blue dark:text-lions-yellow"
            >
              Onze Missie
            </motion.h2>
            <motion.p 
              variants={fadeIn}
              className="text-lg mb-8 dark:text-gray-300"
            >
              "We Serve" is het motto van Lions Clubs International. Als Lions Club Hoorn De Doelen zetten we ons in voor het verbeteren van de kwaliteit van leven van mensen in onze gemeenschap en wereldwijd.
            </motion.p>
            <motion.div 
              variants={fadeIn}
              className="flex justify-center"
            >
              <img 
                src={logoLionsInternational} 
                alt="Lions International Logo" 
                className="h-32 w-auto"
              />
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Bestuur Section 
      <section className="section bg-white dark:bg-lions-dark">
        <div className="container-custom">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={staggerContainer}
          >
            <motion.div 
              variants={fadeIn}
              className="text-center mb-12"
            >
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-lions-blue dark:text-lions-yellow">Ons Bestuur</h2>
              <p className="text-lg max-w-3xl mx-auto dark:text-gray-300">
                Ons bestuur bestaat uit toegewijde vrijwilligers die leiding geven aan onze club en ervoor zorgen dat we onze doelen bereiken.
              </p>
            </motion.div>
            <motion.div 
              variants={fadeIn}
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
            >
             
              <div className="bg-lions-light dark:bg-gray-800 rounded-lg shadow-md overflow-hidden">
                <img 
                  src="/images/board-president.jpg" 
                  alt="Aad Ruijtenberg" 
                  className="w-full h-64 object-cover object-center"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-1">Aad Ruijtenberg</h3>
                  <p className="text-lions-blue dark:text-lions-yellow font-medium mb-4">President</p>
                  <p className="text-gray-600 dark:text-gray-300">
                    Als president leidt Aad onze club en zorgt hij voor de coördinatie van onze activiteiten en projecten.
                  </p>
                </div>
              </div>

             
              <div className="bg-lions-light dark:bg-gray-800 rounded-lg shadow-md overflow-hidden">
                <img 
                  src="/images/board-secretary.jpg" 
                  alt="Erik Boogaard" 
                  className="w-full h-64 object-cover object-center"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-1">Erik Boogaard</h3>
                  <p className="text-lions-blue dark:text-lions-yellow font-medium mb-4">Secretaris</p>
                  <p className="text-gray-600 dark:text-gray-300">
                    Erik houdt de administratie bij, verzorgt de correspondentie en notuleert tijdens vergaderingen.
                  </p>
                </div>
              </div>

             
              <div className="bg-lions-light dark:bg-gray-800 rounded-lg shadow-md overflow-hidden">
                <img 
                  src="/images/board-treasurer.jpg" 
                  alt="Hans Regter" 
                  className="w-full h-64 object-cover object-center"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-1">Hans Regter</h3>
                  <p className="text-lions-blue dark:text-lions-yellow font-medium mb-4">Penningmeester</p>
                  <p className="text-gray-600 dark:text-gray-300">
                    Hans beheert de financiën van onze club en zorgt voor een transparante verantwoording van onze inkomsten en uitgaven.
                  </p>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>
      */}
      {/* CTA Section */}
      <section className="py-16 bg-lions-blue text-white">
        <div className="container-custom">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={staggerContainer}
            className="text-center max-w-3xl mx-auto"
          >
            <motion.h2 
              variants={fadeIn}
              className="text-3xl md:text-4xl font-bold mb-6"
            >
              Word lid van onze club
            </motion.h2>
            <motion.p 
              variants={fadeIn}
              className="text-xl mb-8 text-gray-200"
            >
              Wilt u ook een verschil maken in de gemeenschap? Word lid van Lions Club Hoorn De Doelen en help mee met onze projecten en activiteiten.
            </motion.p>
            <motion.div 
              variants={fadeIn}
              className="flex flex-wrap justify-center gap-4"
            >
              <Link to="/lid-worden" className="btn-secondary">
                Word lid
              </Link>
              <Link to="/contact" className="bg-white text-lions-blue hover:bg-gray-100 font-bold py-2 px-4 rounded transition-colors duration-300">
                Neem contact op
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default About; 